import NewCard from 'shared-assets/components/PaymentSolutions/CardOnFile/NewCard';

angular
  .module('kareo.ui.shared.directives.new-payment-card-on-file', [
    'react'
  ])
  .directive('newPaymentCardOnFile', dcNewPaymentCardOnFile);

dcNewPaymentCardOnFile.$inject = ['reactDirective'];

function dcNewPaymentCardOnFile(reactDirective) {
  const bindings = {
    kareoStripeApiKey: '=',
    addressLine1: '=',
    addressCity: '=',
    addressState: '=',
    addressZipcode: '=',
    makeDefaultCard: '=',
    showMakeDefaultCard: '=',
    showSaveCard: '=',
    onAuthorize: '=',
    onError: '=',
    onSubmit: '=',
    onCancel: '=',
    showCancel: '=',
    showSubmit: '=',
    saveCardLabel: '=',
    saveCardMessage: '=',
  };

  return reactDirective(NewCard, bindings, props => {
    return props;
  });
}
